// Mirror of the bundle's `Penmate.env.checkoutRecoveryEnabled` kill lever:
// absent means ON; "false" / "0" means OFF. With the lever off the Angular
// half goes quiet too - no back interception, no offer rows - so native
// back/swipe behaviour is exactly what it was before this feature.
export const checkoutRecoveryEnabled = (): boolean => {
  try {
    const v = (window as any).Penmate && (window as any).Penmate.env && (window as any).Penmate.env.checkoutRecoveryEnabled;
    if (typeof v === 'string' && v.trim()) {
      const s = v.trim().toLowerCase();
      return s !== 'false' && s !== '0';
    }
    return true;
  } catch (e) {
    return true;
  }
};
